'use client';

import { defaultErrorFallbackAdapter } from '@/components/ErrorScreens/DefaultErrorFallback';
import { HammerUIProvider } from '@liveauctioneers/hammer-ui-core/providers';
import { handleErrorBoundary } from '@/utils/errorHandling/errorBoundaryHandler';
import { ReactNode, useEffect } from 'react';
import { syncSellerFeatureFlagCookies } from '@/utils/featureFlagCookie';
import { Theme } from '@liveauctioneers/hammer-ui-core/types';
import { useRouter } from '@/navigation-client';

const EMPTY_FEATURE_FLAGS: Record<string, boolean> = {};

type HammerProviderProps = {
    children: ReactNode;
    featureFlags?: Record<string, boolean>;
    theme: Theme;
};

export const HammerProvider = ({ children, featureFlags = EMPTY_FEATURE_FLAGS, theme }: HammerProviderProps) => {
    const router = useRouter();

    useEffect(() => {
        syncSellerFeatureFlagCookies(Object.keys(featureFlags));
    }, [featureFlags]);

    return (
        <HammerUIProvider
            defaultFallback={defaultErrorFallbackAdapter}
            featureFlags={featureFlags}
            onError={handleErrorBoundary}
            onLinkClick={router.push}
            theme={theme}
            withoutDatePickerTarget
            withoutJotaiProvider
            withoutModalTarget
            withoutTimePickerTarget
        >
            {children}
        </HammerUIProvider>
    );
};
